import roh from 'typescript-fsa/lib/index.js';
import { auspacken } from './cjs';

type Fabrik = typeof import('typescript-fsa').default;

const modul = roh as unknown as Record<string, unknown>;

/** `actionCreatorFactory` - die Standardausfuhr des Pakets. */
const fabrik = auspacken<Fabrik>(modul);

export default fabrik;
export const actionCreatorFactory = fabrik;
export const isType = modul.isType as typeof import('typescript-fsa').isType;
